import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { Analytics } from "@vercel/analytics/react"
import { useColorModeValue, Box } from "@chakra-ui/react";
import Navbar from './components/layout/NavbarNew';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ServiceDetails from './pages/ServiceDetails';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import ComingSoon from './pages/ComingSoon';
import NotFound from './pages/NotFound';
import './App.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import BackToTopButton from './components/sections/BackToTopButton';
import Chatbot from './components/sections/Chatbot';
import AOS from 'aos';
import BlogPost from './components/sections/BlogPost';
import BlogCategory from './pages/BlogCategory';
import AdminLayout from './layouts/AdminLayout';
import AddPost from './pages/Admin/AddPost';
// import PostsList from './pages/Admin/PostsList'; // Make sure this exists
import Login from './pages/Admin/Login'; // Add this if using auth
import Appointment from './pages/Appointment';

function AppLayout({ children }) {
  const location = useLocation();
  const hideLayout = location.pathname === "/" || location.pathname.startsWith('/admin');

  return (
    <>
      {!hideLayout && <Navbar />}
      {children}
      {!hideLayout && <Footer />}
    </>
  );
}

function App() {
  const navbarBgColor = useColorModeValue("dark", "#000000");
  const [isChatOpen, setIsChatOpen] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <Router>
      <Box className="App" bg={navbarBgColor} minHeight="100vh">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/aboutus" element={<AppLayout><About /></AppLayout>} />
          <Route path="/services" element={<AppLayout><Services /></AppLayout>} />
          <Route path="/contact" element={<AppLayout><Contact /></AppLayout>} />
          <Route path="/appointment" element={<AppLayout><Appointment /></AppLayout>} />
          <Route path="/blog" element={<AppLayout><Blog /></AppLayout>} />
          <Route path="/blog/:id" element={<AppLayout><BlogPost /></AppLayout>} />
          <Route path="/blog/category/:category" element={<AppLayout><BlogCategory /></AppLayout>} />
          <Route path="/coming-soon" element={<ComingSoon />} />

          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route path="add-post" element={<AddPost />} />
            {/* <Route path="posts" element={<PostsList />} /> */}
            {/* Add more admin routes as needed */}
          </Route>

          {/* Auth Route */}
          <Route path="/login" element={<Login />} />

          {/* 404 Route */}
          <Route path="*" element={<NotFound />} />
        </Routes>

        {/* UI Elements */}
        <BackToTopButton bottom={isChatOpen ? '100px' : '20px'} />
        <Chatbot onOpenChange={setIsChatOpen} />
        <Analytics />
      </Box>
    </Router>
  );
}

export default App;